// -- Generated on 15.07.2026 12:48:02 - tc_generator ---

var I18N = require('utils/i18n');

module.exports =
{
  GetCategories: function() {
    return  {
      Actuator: {
      category: 'Actuator',
      name: I18N.TR('Antrieb'),
      url: '#actuator',
      icon: 'icon-actuators',
      addButtonText: I18N.TR('Antrieb hinzufügen'),
      addText: I18N.TR('SAMSON Antrieb'),
      listTitle: I18N.TR('Antriebübersicht'),
      menuText: I18N.TR('Antriebe'),
      menuPos: 21,
      connectActive: false,
      connectsTo: [
        'Gateway',
        'Gateway-RF',
        '55xx56xx',
        ],
      noEdit: false,
      info: {
        'attributes': [
            'serial',
            'firmware',
            ],
        
        'connection': [
            'parent',
            'station',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: true,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Antriebe zugreifen.'),
         title: I18N.TR('Keine Antriebe gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/controller',
      views: {
          settings: 'components/devices/views/generic_modbus/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Controller: {
      category: '55xx56xx',
      name: I18N.TR('Regler'),
      url: '#controller',
      icon: 'fa fa-sliders',
      addButtonText: I18N.TR('Regler hinzufügen'),
      addText: I18N.TR('Heizungsregler (55xx)'),
      listTitle: I18N.TR('Reglerübersicht'),
      menuText: I18N.TR('Regler'),
      menuPos: 20,
      connectActive: false,
      connectsTo: [
        'Gateway',
        'Gateway-RF',
        '55xx56xx',
        ],
      invalidDataRules: [
        { "from": 0, "till": 6499, "value": 32767 },
        { "from": 6500, "till": 9999, "value": 0, "statusMask": 128 },
        { "from": 10000, "till": -1, "value": 32767 },
        ],
      noEdit: false,
      info: {
        'attributes': [
            'serial',
            'firmware',
            'mac_address',
            ],
        
        'connection': [
            'parent',
            'station',
            'schema',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: true,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Regler zugreifen.'),
         title: I18N.TR('Keine Regler gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusBinaryInputError': 0x000080,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusDeviceBusError': 0x000010,
            'DeviceStatusDiffTemperaturTooLarge': 0x002000,
            'DeviceStatusDisinfectionTempNotReached': 0x000004,
            'DeviceStatusHeatMeterError': 0x000200,
            'DeviceStatusMaxChargingTempReached': 0x000008,
            'DeviceStatusMeterBusCommunicationError': 0x000100,
            'DeviceStatusMeterTarifSwitchFailed': 0x000400,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusPressureTooLarge': 0x001000,
            'DeviceStatusPressureTooLow': 0x000800,
            'DeviceStatusSensorFailure': 0x000001,
            'DeviceStatusTempMonitorAlarm': 0x000020,
            'DeviceStatusTrovisIOError': 0x000002,
            'DeviceStatusTwinPumpError': 0x008000,
            'DeviceStatusUnauthorizedAccess': 0x000040,
            'DeviceStatusUnknown': -2,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusBinaryInputError': I18N.TR('Fehlermeldung eines Binäreinganges'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusDeviceBusError': I18N.TR('Fehler vom Gerätebus gemeldet'),
            'DeviceStatusDiffTemperaturTooLarge': I18N.TR('Temperaturdifferenz VF1-RüF1 in RK1 zu groß'),
            'DeviceStatusDisinfectionTempNotReached': I18N.TR('Desinfektionstemperatur nicht erreicht'),
            'DeviceStatusHeatMeterError': I18N.TR('Fehler vom Wärmezähler gemeldet'),
            'DeviceStatusMaxChargingTempReached': I18N.TR('Maximale Ladetemperatur erreicht'),
            'DeviceStatusMeterBusCommunicationError': I18N.TR('Fehler Kommunikation Zählerbus'),
            'DeviceStatusMeterTarifSwitchFailed': I18N.TR('M-Bus Tarifumschaltung WMZ1 fehlgeschlagen'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusPressureTooLarge': I18N.TR('Fliessdruck in RK1 zu groß'),
            'DeviceStatusPressureTooLow': I18N.TR('Fliessdruck in RK1 zu gering'),
            'DeviceStatusSensorFailure': I18N.TR('Sensorausfall'),
            'DeviceStatusTempMonitorAlarm': I18N.TR('Alarm Temperaturüberwachung'),
            'DeviceStatusTrovisIOError': I18N.TR('Ausfall Trovis I/O Modul'),
            'DeviceStatusTwinPumpError': I18N.TR('Fehler Zwillingspumpenbetrieb / Nachspeisung'),
            'DeviceStatusUnauthorizedAccess': I18N.TR('Unerlaubter Zugriff stattgefunden'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1301': false,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': false,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1900': false,
            '1901': false,
            '1902': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1301': false,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': false,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1301': true,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': true,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_circuit_names', name: '' /* I18N.TR('') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_key_number', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_schema', name: 'Anlagenkennziffer' /* I18N.TR('Anlagenkennziffer') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_trovis_io_infos', name: '' /* I18N.TR('') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/controller',
      views: {
          settings: 'components/devices/views/controller/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      FakeGateway: {
      category: 'FakeGateway',
      name: I18N.TR('Simuliertes Gateway'),
      url: '#simulated-gateway',
      icon: 'fa fa-globe deactivated',
      addButtonText: I18N.TR('Gateway registrieren'),
      
      listTitle: I18N.TR('Übersicht simulierter Gateways'),
      menuText: I18N.TR('Simulierte Gateways'),
      menuPos: 60,
      connectActive: true,
      adminOnly: true,
      noEdit: true,
      info: {
        'attributes': [
            'mac_address',
            'serial',
            'firmware',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine simulierten Gateways zugreifen.'),
         title: I18N.TR('Keine simulierten Gateways gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': false,
            '1902': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzte Aktualisierung' /* I18N.TR('Letzte Aktualisierung') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Angelegt am' /* I18N.TR('Angelegt am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/gateway',
      views: {
          settings: 'components/devices/views/gateway/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      FakeMeter: {
      category: 'FakeMeter',
      name: I18N.TR('Simulierte Zähler'),
      url: '#simulated-meter',
      icon: 'wi wi-barometer deactivated',
      addButtonText: I18N.TR('Zähler hinzufügen'),
      addText: I18N.TR('Wärmemengenzähler'),
      listTitle: I18N.TR('Übersicht simulierter Zähler'),
      menuText: I18N.TR('Simulierte Zähler'),
      menuPos: 61,
      connectActive: false,
      connectsTo: [
        'FakeGateway',
        ],
      adminOnly: true,
      noEdit: true,
      info: {
        'attributes': [
            'serial',
            'hardware',
            'firmware',
            ],
        
        'connection': [
            'parent',
            'address',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine simulierten Zähler zugreifen.'),
         title: I18N.TR('Keine Zähler gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusAppError': 0x000200,
            'DeviceStatusDelayed': -1,
            'DeviceStatusInvalidState': 0x000300,
            'DeviceStatusLowEnergyReserve': 0x000400,
            'DeviceStatusMeterMbus': 0xFF7F0000,
            'DeviceStatusMeterSpecific1': 0x002000,
            'DeviceStatusMeterSpecific2': 0x004000,
            'DeviceStatusMeterSpecific3': 0x008000,
            'DeviceStatusMeterTimeout': 0x800000,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusPermError': 0x000800,
            'DeviceStatusTempError': 0x001000,
            },
          messages: {
            'DeviceStatusAppError': I18N.TR('Beliebiger Applikationsfehler'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusInvalidState': I18N.TR('Ungewöhnlicher Zustand'),
            'DeviceStatusLowEnergyReserve': I18N.TR('Energiereserve niedrig'),
            'DeviceStatusMeterMbus': I18N.TR('MBus-Fehler'),
            'DeviceStatusMeterSpecific1': I18N.TR('Zählerspezifischer Fehler 1'),
            'DeviceStatusMeterSpecific2': I18N.TR('Zählerspezifischer Fehler 2'),
            'DeviceStatusMeterSpecific3': I18N.TR('Zählerspezifischer Fehler 3'),
            'DeviceStatusMeterTimeout': I18N.TR('Zähler antwortet nicht'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusPermError': I18N.TR('Permanenter Fehler'),
            'DeviceStatusTempError': I18N.TR('Temporärer Fehler'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1200': false,
            '1400': false,
            '1900': false,
            '1901': false,
            },
        
         expert: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1200': false,
            '1400': false,
            },
        
         standard: {
            '1001': false,
            '1101': true,
            '1103': true,
            '1200': false,
            '1400': false,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_address', name: 'Primäradresse' /* I18N.TR('Primäradresse') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Version' /* I18N.TR('Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hersteller-ID' /* I18N.TR('Hersteller-ID') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzte Aktualisierung' /* I18N.TR('Letzte Aktualisierung') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mbus_index', name: '' /* I18N.TR('') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_parent_category', name: '' /* I18N.TR('') */  },
      { id: '#_parent_type', name: '' /* I18N.TR('') */  },
      { id: '#_registered', name: 'Angelegt am' /* I18N.TR('Angelegt am') */  },
      { id: '#_serial', name: 'Identnummer' /* I18N.TR('Identnummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_zbd_file', name: 'Erweiterungsdatei' /* I18N.TR('Erweiterungsdatei') */  },
      ],
      base_controller: true,
      views: {
          settings: 'components/devices/views/meter/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Gateway: {
      category: 'Gateway',
      name: I18N.TR('Gateway'),
      url: '#gateway',
      icon: 'fa fa-globe',
      addButtonText: I18N.TR('Gateway registrieren'),
      
      listTitle: I18N.TR('Gatewayübersicht'),
      menuText: I18N.TR('Gateways'),
      menuPos: 10,
      connectActive: true,
      noEdit: false,
      info: {
        'attributes': [
            'mac_address',
            'serial',
            'firmware',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Gateways zugreifen.'),
         title: I18N.TR('Keine Gateways gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            'GatewayStatusCommError': 0x000001,
            'GatewayStatusInvalidPIN': 0x000008,
            'GatewayStatusLockSIM': 0x000004,
            'GatewayStatusMBusError': 0x000080,
            'GatewayStatusMeterError': 0x000100,
            'GatewayStatusMissingSIM': 0x000002,
            'GatewayStatusModemOffline': 0x000020,
            'GatewayStatusModemSilent': 0x000010,
            'GatewayStatusNoSingal': 0x000040,
            'GatewayStatusPortalError': 0x000200,
            'GatewayStatusRTUtoTCPError': 0x000800,
            'GatewayStatusZBDFileError': 0x000400,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            'GatewayStatusCommError': I18N.TR('RS232/RS485 Kommunikationsfehler'),
            'GatewayStatusInvalidPIN': I18N.TR('PIN ungültig'),
            'GatewayStatusLockSIM': I18N.TR('SIM-Lock'),
            'GatewayStatusMBusError': I18N.TR('MBus-Fehler'),
            'GatewayStatusMeterError': I18N.TR('Zähler-Fehler'),
            'GatewayStatusMissingSIM': I18N.TR('SIM Karte fehlt'),
            'GatewayStatusModemOffline': I18N.TR('GPRS-Modem Offline'),
            'GatewayStatusModemSilent': I18N.TR('GPRS-Modem stumm'),
            'GatewayStatusNoSingal': I18N.TR('GPRS kein Signal'),
            'GatewayStatusPortalError': I18N.TR('Portal Verbindungsfehler'),
            'GatewayStatusRTUtoTCPError': I18N.TR('RTU/TCP Kommunikationsfehler'),
            'GatewayStatusZBDFileError': I18N.TR('ZBD-Datei Fehler'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': false,
            '1902': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/gateway',
      views: {
          settings: 'components/devices/views/gateway/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      GatewayController: {
      category: 'GatewayController',
      name: I18N.TR('Gateway'),
      url: '#gw-controller',
      icon: 'fa fa-sliders',
      addButtonText: I18N.TR('Gateway registrieren'),
      
      listTitle: I18N.TR('Gatewayübersicht'),
      menuText: I18N.TR('Gateways'),
      menuPos: 10,
      connectActive: true,
      invalidDataRules: [
        { "from": 0, "till": 6499, "value": 32767 },
        { "from": 6500, "till": 9999, "value": 0, "statusMask": 128 },
        { "from": 10000, "till": -1, "value": 32767 },
        ],
      noEdit: false,
      info: {
        'attributes': [
            'mac_address',
            'serial',
            'firmware',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Gateways zugreifen.'),
         title: I18N.TR('Keine Gateways gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            'GatewayStatusCommError': 0x000001,
            'GatewayStatusInvalidPIN': 0x000008,
            'GatewayStatusLockSIM': 0x000004,
            'GatewayStatusMBusError': 0x000080,
            'GatewayStatusMeterError': 0x000100,
            'GatewayStatusMissingSIM': 0x000002,
            'GatewayStatusModemOffline': 0x000020,
            'GatewayStatusModemSilent': 0x000010,
            'GatewayStatusNoSingal': 0x000040,
            'GatewayStatusPortalError': 0x000200,
            'GatewayStatusRTUtoTCPError': 0x000800,
            'GatewayStatusZBDFileError': 0x000400,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            'GatewayStatusCommError': I18N.TR('RS232/RS485 Kommunikationsfehler'),
            'GatewayStatusInvalidPIN': I18N.TR('PIN ungültig'),
            'GatewayStatusLockSIM': I18N.TR('SIM-Lock'),
            'GatewayStatusMBusError': I18N.TR('MBus-Fehler'),
            'GatewayStatusMeterError': I18N.TR('Zähler-Fehler'),
            'GatewayStatusMissingSIM': I18N.TR('SIM Karte fehlt'),
            'GatewayStatusModemOffline': I18N.TR('GPRS-Modem Offline'),
            'GatewayStatusModemSilent': I18N.TR('GPRS-Modem stumm'),
            'GatewayStatusNoSingal': I18N.TR('GPRS kein Signal'),
            'GatewayStatusPortalError': I18N.TR('Portal Verbindungsfehler'),
            'GatewayStatusRTUtoTCPError': I18N.TR('RTU/TCP Kommunikationsfehler'),
            'GatewayStatusZBDFileError': I18N.TR('ZBD-Datei Fehler'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1301': false,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': false,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1900': false,
            '1901': false,
            '1902': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1301': false,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': false,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1301': true,
            '1302': false,
            '1303': false,
            '1304': false,
            '1305': false,
            '1306': true,
            '1311': false,
            '1312': false,
            '1313': false,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_circuit_names', name: '' /* I18N.TR('') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_key_number', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_schema', name: 'Anlagenkennziffer' /* I18N.TR('Anlagenkennziffer') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_trovis_io_infos', name: '' /* I18N.TR('') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/gateway',
      views: {
          settings: 'components/devices/views/gateway/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      GatewayRF: {
      category: 'Gateway-RF',
      name: I18N.TR('SAM LAN Gateway'),
      url: '#gateway-rf',
      icon: 'fa fa-signal',
      addButtonText: I18N.TR('SAM LAN Gateway registrieren'),
      
      listTitle: I18N.TR('SAM LAN Gatewayübersicht'),
      menuText: I18N.TR('SAM LAN Gateways'),
      menuPos: 11,
      connectActive: true,
      noEdit: false,
      noReinitialize: true,
      info: {
        'attributes': [
            'mac_address',
            'serial',
            'firmware',
            ],
        
        'connection': [
            'parent',
            'station',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine SAM LAN Gateways zugreifen.'),
         title: I18N.TR('Keine SAM LAN Gateways gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            'GatewayRfStatusCoffeeMediumNotReady': 0x001000,
            'GatewayRfStatusCoffeeWriteNotPossible': 0x002000,
            'GatewayRfStatusControllerNotFound': 0x008000,
            'GatewayRfStatusKonfFlashFehler': 0x000400,
            'GatewayRfStatusMBusError': 0x000100,
            'GatewayRfStatusMbListStatListKorrupt': 0x004000,
            'GatewayRfStatusMeterError': 0x000200,
            'GatewayRfStatusNVDataReset': 0x000002,
            'GatewayRfStatusRF_TRX_Fehler': 0x000800,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            'GatewayRfStatusCoffeeMediumNotReady': I18N.TR('Dateisystem (Flash) nicht verfügbar'),
            'GatewayRfStatusCoffeeWriteNotPossible': I18N.TR('Dateisystem (Flash) nicht beschreibbar'),
            'GatewayRfStatusControllerNotFound': I18N.TR('Regler nach mehrfachem Scan-Durchlauf nicht gefunden'),
            'GatewayRfStatusKonfFlashFehler': I18N.TR('Problem mit SPI-Flash'),
            'GatewayRfStatusMBusError': I18N.TR('MBus-Fehler'),
            'GatewayRfStatusMbListStatListKorrupt': I18N.TR('Benutzerdefinierte Datenliste für Aggregationsknoten nicht nutzbar'),
            'GatewayRfStatusMeterError': I18N.TR('Zähler-Fehler'),
            'GatewayRfStatusNVDataReset': I18N.TR('Werkseinstellung gelesen'),
            'GatewayRfStatusRF_TRX_Fehler': I18N.TR('Funktransceiver-Fehler'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': false,
            '1902': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/gateway',
      views: {
          settings: 'components/devices/views/gateway/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Meter: {
      category: 'Meter',
      name: I18N.TR('Zähler'),
      url: '#meter',
      icon: 'wi wi-barometer',
      addButtonText: I18N.TR('Zähler hinzufügen'),
      addText: I18N.TR('Wärmemengenzähler'),
      listTitle: I18N.TR('Zählerübersicht'),
      menuText: I18N.TR('Zähler'),
      menuPos: 30,
      connectActive: false,
      connectsTo: [
        'Gateway',
        'Gateway-RF',
        '55xx56xx',
        'GenericModbus',
        ],
      noEdit: false,
      info: {
        'attributes': [
            'serial',
            'hardware',
            'firmware',
            ],
        
        'connection': [
            'parent',
            'address',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: true,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Zähler zugreifen.'),
         title: I18N.TR('Keine Zähler gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusAppError': 0x000200,
            'DeviceStatusDelayed': -1,
            'DeviceStatusInvalidState': 0x000300,
            'DeviceStatusLowEnergyReserve': 0x000400,
            'DeviceStatusMeterMbus': 0xFF7F0000,
            'DeviceStatusMeterSpecific1': 0x002000,
            'DeviceStatusMeterSpecific2': 0x004000,
            'DeviceStatusMeterSpecific3': 0x008000,
            'DeviceStatusMeterTimeout': 0x800000,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusPermError': 0x000800,
            'DeviceStatusTempError': 0x001000,
            },
          messages: {
            'DeviceStatusAppError': I18N.TR('Beliebiger Applikationsfehler'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusInvalidState': I18N.TR('Ungewöhnlicher Zustand'),
            'DeviceStatusLowEnergyReserve': I18N.TR('Energiereserve niedrig'),
            'DeviceStatusMeterMbus': I18N.TR('MBus-Fehler'),
            'DeviceStatusMeterSpecific1': I18N.TR('Zählerspezifischer Fehler 1'),
            'DeviceStatusMeterSpecific2': I18N.TR('Zählerspezifischer Fehler 2'),
            'DeviceStatusMeterSpecific3': I18N.TR('Zählerspezifischer Fehler 3'),
            'DeviceStatusMeterTimeout': I18N.TR('Zähler antwortet nicht'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusPermError': I18N.TR('Permanenter Fehler'),
            'DeviceStatusTempError': I18N.TR('Temporärer Fehler'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1200': false,
            '1400': false,
            '1900': false,
            '1901': false,
            },
        
         expert: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1200': false,
            '1400': false,
            },
        
         standard: {
            '1001': false,
            '1101': true,
            '1103': true,
            '1200': false,
            '1400': false,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_address', name: 'Primäradresse' /* I18N.TR('Primäradresse') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Version' /* I18N.TR('Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hersteller-ID' /* I18N.TR('Hersteller-ID') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mbus_index', name: '' /* I18N.TR('') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_parent_category', name: '' /* I18N.TR('') */  },
      { id: '#_parent_type', name: '' /* I18N.TR('') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Identnummer' /* I18N.TR('Identnummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_zbd_file', name: 'Erweiterungsdatei' /* I18N.TR('Erweiterungsdatei') */  },
      ],
      base_controller: true,
      views: {
          settings: 'components/devices/views/meter/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Modbus: {
      category: 'GenericModbus',
      name: I18N.TR('Modbus'),
      url: '#modbus',
      icon: 'fa fa-question',
      addButtonText: I18N.TR('Modbus-Gerät registrieren'),
      addText: I18N.TR('Generisches Modbus-Gerät'),
      listTitle: I18N.TR('Modbus-Geräteübersicht'),
      menuText: I18N.TR('Modbus'),
      menuPos: 40,
      connectActive: false,
      connectsTo: [
        'Gateway',
        'Gateway-RF',
        '55xx56xx',
        ],
      noEdit: false,
      info: {
        'attributes': [
            'serial',
            'firmware',
            'hardware',
            ],
        
        'connection': [
            'parent',
            'station',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: true,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Modbus-Geräte zugreifen.'),
         title: I18N.TR('Keine Modbus-Geräte gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': false,
            },
        
         expert: {
            '1001': false,
            '1100': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1100': true,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      base_controller: true,
      views: {
          settings: 'components/devices/views/generic_modbus/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      SamHomeGrid: {
      category: 'SamHomeGrid',
      name: I18N.TR('SAM HOME GRID'),
      url: '#sam-home-grid',
      icon: 'fa fa-home',
      addButtonText: I18N.TR('SAM HOME GRID registrieren'),
      
      listTitle: I18N.TR('SAM HOME GRID Übersicht'),
      menuText: I18N.TR('SAM HOME GRID'),
      menuPos: 12,
      connectActive: false,
      noEdit: false,
      noReinitialize: false,
      info: {
        'attributes': [
            'mac_address',
            'serial',
            'firmware',
            'kernel_version',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine SAM HOME GRID Geräte zugreifen.'),
         title: I18N.TR('Keine SAM HOME GRID Geräte gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            },
      },
      permissions: {
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_kernel_version', name: 'Kernel Version' /* I18N.TR('Kernel Version') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mac_address', name: 'MAC-Adresse' /* I18N.TR('MAC-Adresse') */  },
      { id: '#_max_modbus_group_distance', name: 'Modbus-Anfrage Gruppierungsdistanz' /* I18N.TR('Modbus-Anfrage Gruppierungsdistanz') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      controller: 'components/devices/controllers/gateway',
      views: {
          settings: 'components/devices/views/gateway/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Sensor: {
      category: 'Sensor',
      name: I18N.TR('Sensoren'),
      url: '#sensor',
      icon: 'fa fa-bullseye',
      
      
      listTitle: I18N.TR('Sensorübersicht'),
      menuText: I18N.TR('Sensoren'),
      menuPos: 70,
      connectActive: false,
      noEdit: false,
      noReinitialize: true,
      info: {
        'attributes': [
            'serial',
            'firmware',
            'hardware',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: false,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine Sensoren zugreifen.'),
         title: I18N.TR('Keine Sensoren gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1900': false,
            },
        
         expert: {
            '1001': false,
            '1101': false,
            '1103': false,
            '1400': false,
            '1902': false,
            },
        
         standard: {
            '1001': false,
            '1101': true,
            '1103': true,
            '1400': false,
            '1902': true,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzter Kontakt' /* I18N.TR('Letzter Kontakt') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Registriert am' /* I18N.TR('Registriert am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      base_controller: true,
      views: {
          settings: 'components/devices/views/meter/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  
      Virtual: {
      category: 'Virtual',
      name: I18N.TR('Virtuelles Gerät'),
      url: '#virtual',
      icon: 'fa fa-sitemap',
      addButtonText: I18N.TR('Virtuelles Gerät anlegen'),
      addText: I18N.TR('Virtuelles Gerät'),
      addTrigger: 'virtual:device:new',
      listTitle: I18N.TR('Übersicht virtueller Geräte'),
      menuText: I18N.TR('Virtuelle Geräte'),
      menuPos: 50,
      connectActive: false,
      noEdit: false,
      noReinitialize: true,
      info: {
        'attributes': [
            'filter',
            ],
        
        'dates': [
            'last_seen',
            'registered',
            ],
        },
      canAdd: true,
      noData: {
         text:  I18N.TR('Momentan können Sie auf keine virtuellen Geräte zugreifen.'),
         title: I18N.TR('Keine virtuellen Geräte gefunden'),
      },
      statusErrors: {
          codes: {
            'DeviceStatusArchived': -4,
            'DeviceStatusDeactivated': -3,
            'DeviceStatusDelayed': -1,
            'DeviceStatusOK': 0x000000,
            'DeviceStatusUnknown': -2,
            },
          messages: {
            'DeviceStatusArchived': I18N.TR('Gerät archiviert'),
            'DeviceStatusDeactivated': I18N.TR('Gerät inaktiv'),
            'DeviceStatusDelayed': I18N.TR('Gerät nicht erreichbar'),
            'DeviceStatusOK': I18N.TR('Gerät betriebsbereit'),
            'DeviceStatusUnknown': I18N.TR('Gerätestatus unbekannt'),
            },
      },
      permissions: {
        
         admin: {
            '1001': false,
            '1101': true,
            '1103': false,
            '1400': false,
            '1900': false,
            '1901': true,
            },
        
         expert: {
            '1001': false,
            '1101': true,
            '1103': false,
            '1400': false,
            },
        
         standard: {
            '1001': false,
            '1101': true,
            '1103': true,
            '1400': false,
            },
        },
      columns: [
      { id: '#_activation_status', name: '' /* I18N.TR('') */  },
      { id: '#_alarm_count', name: 'Alarmanzahl' /* I18N.TR('Alarmanzahl') */  },
      { id: '#_can_config', name: '' /* I18N.TR('') */  },
      { id: '#_can_share', name: '' /* I18N.TR('') */  },
      { id: '#_can_write', name: '' /* I18N.TR('') */  },
      { id: '#_capabilities', name: '' /* I18N.TR('') */  },
      { id: '#_category', name: 'Gerätetyp' /* I18N.TR('Gerätetyp') */  },
      { id: '#_children', name: 'Angeschlossene Geräte' /* I18N.TR('Angeschlossene Geräte') */  },
      { id: '#_company', name: '' /* I18N.TR('') */  },
      { id: '#_data_device_id', name: '' /* I18N.TR('') */  },
      { id: '#_device_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_filter', name: 'Filter' /* I18N.TR('Filter') */  },
      { id: '#_firmware', name: 'Firmware Version' /* I18N.TR('Firmware Version') */  },
      { id: '#_formatInfos', name: '' /* I18N.TR('') */  },
      { id: '#_groups', name: 'Labels' /* I18N.TR('Labels') */  },
      { id: '#_hardware', name: 'Hardware Version' /* I18N.TR('Hardware Version') */  },
      { id: '#_id', name: '' /* I18N.TR('') */  },
      { id: '#_interval', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration', name: '' /* I18N.TR('') */  },
      { id: '#_last_configuration_crc', name: '' /* I18N.TR('') */  },
      { id: '#_last_seen', name: 'Letzte Aktualisierung' /* I18N.TR('Letzte Aktualisierung') */  },
      { id: '#_location', name: '' /* I18N.TR('') */  },
      { id: '#_mode', name: '' /* I18N.TR('') */  },
      { id: '#_name', name: 'Name' /* I18N.TR('Name') */  },
      { id: '#_parent', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      { id: '#_registered', name: 'Angelegt am' /* I18N.TR('Angelegt am') */  },
      { id: '#_serial', name: 'Seriennummer' /* I18N.TR('Seriennummer') */  },
      { id: '#_series', name: '' /* I18N.TR('') */  },
      { id: '#_state_data_names', name: '' /* I18N.TR('') */  },
      { id: '#_station', name: 'Stationsadresse' /* I18N.TR('Stationsadresse') */  },
      { id: '#_status', name: 'Status' /* I18N.TR('Status') */  },
      { id: '#_status_data', name: '' /* I18N.TR('') */  },
      { id: '#_tags', name: 'Öffentliche Labels' /* I18N.TR('Öffentliche Labels') */  },
      { id: '#_timeout', name: '' /* I18N.TR('') */  },
      { id: '#_type', name: 'Type' /* I18N.TR('Type') */  },
      { id: '#_wired_to', name: 'Angeschlossen an' /* I18N.TR('Angeschlossen an') */  },
      ],
      base_controller: true,
      views: {
          settings: 'components/devices/views/virtual/settings_view',
          list:     'components/devices/views/common/base_device_list_view'
      }
    },
  }
 },
 InitRequired: function() {
    require('components/devices/controllers/controller');
    require('components/devices/controllers/gateway');
    require('components/devices/views/common/base_device_list_view');
    require('components/devices/views/controller/settings_view');
    require('components/devices/views/gateway/settings_view');
    require('components/devices/views/generic_modbus/settings_view');
    require('components/devices/views/meter/settings_view');
    require('components/devices/views/virtual/settings_view');
    },
  InitConsts: function() {
    return {
      Operators: [
        { desc: I18N.TR('Durchschnitt (a + b) / 2'), format: I18N.TR('Ø($1, $2)'), value: '#', name: 'Ø' },
        { desc: I18N.TR('Delta |a - b|'), format: I18N.TR('Δ($1, $2)'), value: '$', name: 'Δ' },
        { desc: I18N.TR('Summe a + b'), format: '', value: '+', name: '+' },
        { desc: I18N.TR('Differenz a - b'), format: '', value: '-', name: '-' },
        { desc: I18N.TR('Minimum (a, b)'), format: I18N.TR('MIN($1, $2)'), value: 'N', name: 'MIN' },
        { desc: I18N.TR('Maximum (a, b)'), format: I18N.TR('MAX($1, $2)'), value: 'X', name: 'MAX' },
        { desc: I18N.TR('Vergleich a mit % von b'), format: I18N.TR('$1 @comparison von $2'), value: 'Z', name: '%' },
        ],
      Comparison: [
        { for_list: false, for_status: false, format: '', k: '<', o: '<' },
        { for_list: false, for_status: false, format: '', k: '<=', o: '<=' },
        { for_list: true, for_status: false, format: '', k: '<>', o: '<>' },
        { for_list: true, for_status: false, format: '', k: '=', o: '=' },
        { for_list: false, for_status: false, format: '', k: '>', o: '>' },
        { for_list: false, for_status: false, format: '', k: '>=', o: '>=' },
        { for_list: false, for_status: true, format: I18N.TR('$1 - alle'), k: 'ALL', o: I18N.TR('alle von') },
        { for_list: false, for_status: true, format: I18N.TR('$1 - mindestens eins'), k: 'ANY', o: I18N.TR('eins von') },
        { for_list: false, for_status: true, format: I18N.TR('$1 - kein davon'), k: 'NONEOF', o: I18N.TR('keine von') },
        ],
      Units: {
		"prefix": {
			"G": 1000000000,
			"M": 1000000,
			"c": 0.01,
			"d": 0.1,
			"dc": 0.1,
			"dk": 0.1,
			"h": 100,
			"k": 1000,
			"m": 0.001,
			"n": 1e-9,
			"µ": 0.000001
		},
		"units": {
			"B": {
				"prefix": [
					"k",
					"M",
					"G"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"Bar": {
				"prefix": [
					"m"
				],
				"output_prefix": null,
				"related": "Pa",
				"related_k": 100000,
				"hidden": true
			},
			"Hz": {
				"prefix": [
					"k",
					"M",
					"G"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"J": {
				"prefix": [
					"k",
					"M",
					"G",
					"m"
				],
				"output_prefix": null,
				"related": "Ws",
				"related_k": 1,
				"hidden": false
			},
			"N": {
				"prefix": [
					"k",
					"M",
					"G"
				],
				"output_prefix": null,
				"related": "kgm/s²",
				"related_k": 1,
				"hidden": false
			},
			"Pa": {
				"prefix": [
					"k",
					"h",
					"M"
				],
				"output_prefix": null,
				"related": "N/m²",
				"related_k": 1,
				"hidden": false
			},
			"V": {
				"prefix": [
					"m",
					"k",
					"M",
					"µ"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"W": {
				"prefix": [
					"k",
					"M",
					"G",
					"m"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"bar": {
				"prefix": [
					"m"
				],
				"output_prefix": null,
				"related": "Pa",
				"related_k": 100000,
				"hidden": true
			},
			"cbm": {
				"prefix": null,
				"output_prefix": null,
				"related": "m³",
				"related_k": 1,
				"hidden": true
			},
			"g": {
				"prefix": [
					"k",
					"m",
					"dk"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"h": {
				"prefix": [],
				"output_prefix": null,
				"related": "s",
				"related_k": 3600,
				"hidden": false
			},
			"l": {
				"prefix": [
					"m",
					"c",
					"dc",
					"h"
				],
				"output_prefix": [
					"m"
				],
				"related": "m³",
				"related_k": 0.001,
				"hidden": false
			},
			"m": {
				"prefix": [
					"m",
					"n",
					"µ",
					"k",
					"d",
					"c"
				],
				"output_prefix": [
					"m",
					"n",
					"µ",
					"k",
					"c"
				],
				"related": "",
				"related_k": 0,
				"hidden": false
			},
			"min": {
				"prefix": null,
				"output_prefix": null,
				"related": "s",
				"related_k": 60,
				"hidden": false
			},
			"s": {
				"prefix": [
					"m",
					"µ",
					"n"
				],
				"output_prefix": null,
				"related": "",
				"related_k": 0,
				"hidden": false
			}
		},
		"available": [
			[
				"dB"
			],
			[
				"J",
				"MJ",
				"GJ",
				"kJ"
			],
			[
				"Wh",
				"kWh",
				"MWh"
			],
			[
				"m³",
				"l",
				"ml",
				"mm³"
			],
			[
				"m³",
				"dm³",
				"cm³",
				"mm³"
			],
			[
				"m³",
				"hl",
				"l",
				"ml",
				"mm³"
			],
			[
				"kg/m³",
				"g/cm³"
			],
			[
				"ml/h",
				"l/h",
				"m³/h"
			],
			[
				"m³/s",
				"l/s"
			],
			[
				"km/h",
				"m/s"
			],
			[
				"m²",
				"mm²",
				"cm²"
			],
			[
				"B",
				"kB",
				"MB",
				"GB"
			]
		],
		"exponentiation": {
			"²": 2,
			"³": 3
		},
		"tests": {
			"available": [
				{
					"values": null,
					"value": 0,
					"src_unit": "dm³",
					"result": "[cm³ dm³ hl l ml mm³ m³]",
					"dest_unit": ""
				},
				{
					"values": null,
					"value": 0,
					"src_unit": "kg/m³",
					"result": "[g/cm³ kg/m³]",
					"dest_unit": ""
				},
				{
					"values": null,
					"value": 0,
					"src_unit": "l/h",
					"result": "[l/h l/s ml/h m³/h m³/s]",
					"dest_unit": ""
				},
				{
					"values": null,
					"value": 0,
					"src_unit": "V/m",
					"result": "[V/m]",
					"dest_unit": ""
				}
			],
			"convert": [
				{
					"values": null,
					"value": 50,
					"src_unit": "l",
					"result": "0.05",
					"dest_unit": "m³"
				},
				{
					"values": null,
					"value": 50,
					"src_unit": "dcl",
					"result": "5e+06",
					"dest_unit": "mm³"
				},
				{
					"values": null,
					"value": 2,
					"src_unit": "l/s",
					"result": "72",
					"dest_unit": "hl/h"
				},
				{
					"values": null,
					"value": 2,
					"src_unit": "l/s",
					"result": "7.2",
					"dest_unit": "m³/h"
				},
				{
					"values": null,
					"value": 2,
					"src_unit": "l/s",
					"result": "7.2e+09",
					"dest_unit": "mm³/h"
				},
				{
					"values": null,
					"value": 2,
					"src_unit": "l/s",
					"result": "7.2e+06",
					"dest_unit": "ml/h"
				},
				{
					"values": null,
					"value": 1,
					"src_unit": "kWh",
					"result": "3.6e+06",
					"dest_unit": "J"
				},
				{
					"values": null,
					"value": 72,
					"src_unit": "MJ/m³",
					"result": "0.02",
					"dest_unit": "kWh/l"
				},
				{
					"values": null,
					"value": 10,
					"src_unit": "m/s",
					"result": "36",
					"dest_unit": "km/h"
				},
				{
					"values": null,
					"value": 36,
					"src_unit": "km/h",
					"result": "10",
					"dest_unit": "m/s"
				},
				{
					"values": null,
					"value": 36,
					"src_unit": "km²/h",
					"result": "10000",
					"dest_unit": "m²/s"
				},
				{
					"values": null,
					"value": 36,
					"src_unit": "mm",
					"result": "36",
					"dest_unit": "mm"
				},
				{
					"values": null,
					"value": 1,
					"src_unit": "M J / m³",
					"result": "0",
					"dest_unit": "kWh/l"
				},
				{
					"values": null,
					"value": 1,
					"src_unit": "bar",
					"result": "100000",
					"dest_unit": "Pa"
				},
				{
					"values": null,
					"value": 1,
					"src_unit": "bar",
					"result": "1000",
					"dest_unit": "hPa"
				},
				{
					"values": null,
					"value": 25,
					"src_unit": "°C",
					"result": "25",
					"dest_unit": "°C"
				},
				{
					"values": null,
					"value": 25,
					"src_unit": "°C",
					"result": "0",
					"dest_unit": "mm"
				}
			],
			"fit": [
				{
					"values": [
						100
					],
					"value": 0,
					"src_unit": "dB",
					"result": "dB",
					"dest_unit": ""
				},
				{
					"values": [
						1
					],
					"value": 0,
					"src_unit": "dm³",
					"result": "dm³",
					"dest_unit": ""
				},
				{
					"values": [
						500000
					],
					"value": 0,
					"src_unit": "dm³",
					"result": "m³",
					"dest_unit": ""
				},
				{
					"values": [
						5000000
					],
					"value": 0,
					"src_unit": "dm³",
					"result": "m³",
					"dest_unit": ""
				},
				{
					"values": [
						0.0000094
					],
					"value": 0,
					"src_unit": "m³",
					"result": "ml",
					"dest_unit": ""
				},
				{
					"values": [
						1
					],
					"value": 0,
					"src_unit": "ml",
					"result": "ml",
					"dest_unit": ""
				},
				{
					"values": [
						1000
					],
					"value": 0,
					"src_unit": "ml",
					"result": "l",
					"dest_unit": ""
				},
				{
					"values": [
						1000000
					],
					"value": 0,
					"src_unit": "ml",
					"result": "m³",
					"dest_unit": ""
				},
				{
					"values": [
						10000
					],
					"value": 0,
					"src_unit": "ml",
					"result": "l",
					"dest_unit": ""
				},
				{
					"values": [
						110000
					],
					"value": 0,
					"src_unit": "cm²",
					"result": "m²",
					"dest_unit": ""
				},
				{
					"values": [
						0.001
					],
					"value": 0,
					"src_unit": "m³",
					"result": "l",
					"dest_unit": ""
				},
				{
					"values": [
						0.000001
					],
					"value": 0,
					"src_unit": "m³",
					"result": "ml",
					"dest_unit": ""
				},
				{
					"values": [
						1e-9
					],
					"value": 0,
					"src_unit": "m³",
					"result": "mm³",
					"dest_unit": ""
				},
				{
					"values": [
						-150000,
						0,
						150000
					],
					"value": 0,
					"src_unit": "J",
					"result": "kJ",
					"dest_unit": ""
				},
				{
					"values": [
						-150000,
						0
					],
					"value": 0,
					"src_unit": "J",
					"result": "kJ",
					"dest_unit": ""
				},
				{
					"values": [
						2,
						2,
						2
					],
					"value": 0,
					"src_unit": "dm³",
					"result": "dm³",
					"dest_unit": ""
				},
				{
					"values": [
						1,
						2
					],
					"value": 0,
					"src_unit": "mbar",
					"result": "hPa",
					"dest_unit": ""
				}
			]
		}
	}
    }
  },
}
